import { Navigate, Route, Routes, Outlet } from 'react-router-dom'
import ManagementDashboard from './components/ManagementDashboard'
import { CompaniesList } from './components/CompaniesList'
import { VesselsList } from './components/VesselsList'
import { CompanyAdminList } from './components/CompanyAdminList'
import { VoyageList } from '../operations/components/VoyageList'
import UserManagement from './components/UserManagement'
import VendorManagement from './components/VendorManagement'
import AdminAccessManagement from './components/AdminAccessManagement'
import {useAuth} from '../auth'
import { canOpenAdminAccessManagementByPermission } from './core/adminPermissions'

const AccessManagementGuard = () => {
  const { currentUser, hasAnyPermission, isSuperAdmin } = useAuth()
  if (!currentUser) return null
  const role = (currentUser as Record<string, any> | null | undefined)?.role
  const effectiveBehaviorType =
    role?.effectiveBehaviorType || role?.baseRoleType || role?.roleType || (currentUser as any)?.roleType || null
  if (!canOpenAdminAccessManagementByPermission(hasAnyPermission, isSuperAdmin, effectiveBehaviorType)) {
    return <Navigate to='/manage/vessels' replace />
  }
  return <AdminAccessManagement />
}

const ManagePage = () => {
    return (
        <Routes>
            <Route element={<Outlet />}>
                <Route
                    index
                    element={<Navigate to='dashboard' replace />}  // ✅ Default to dashboard
                />
                <Route
                    path='dashboard'
                    element={<ManagementDashboard />}
                />
                <Route
                    path='subcompanies'
                    element={<CompaniesList />}
                />
                <Route
                    path='companies'
                    element={<CompanyAdminList />}
                />
                <Route
                    path='vessels'
                    element={<VesselsList />}
                />
                <Route
                    path='voyages'
                    element={<VoyageList />}
                />
                <Route
                    path='usermanagement'
                    element={<UserManagement />}
                />
                <Route
                    path='vendormanagement'
                    element={<VendorManagement />}
                />
                <Route path='role-permissions' element={<AccessManagementGuard />} />
                <Route path='access-management' element={<Navigate to='/manage/role-permissions' replace />} />
            </Route>
        </Routes>
    )
}

export default ManagePage
